import FasterConfiguration from 'Faster/FasterConfiguration';
import FasterRequest from 'Faster/network/FasterRequest';
import fetchPonyfill from 'fetch-ponyfill';
import ServerDate from 'Faster/model/ServerDate';
import { polyfill } from 'es6-promise';

polyfill();

const delay = (time: number) => (data?) => new Promise((resolve) => setTimeout(() => resolve(data), time));

const { fetch, Headers } = fetchPonyfill();
export default class FasterHttpClient {
  private baseUrl: string;
  private baseHeaders: object;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private currentRequest: Promise<any> = Promise.resolve();

  public constructor(configuration: FasterConfiguration) {
    this.baseUrl = configuration.baseUrl;
    this.baseHeaders = {
      [FasterConfiguration.FASTER_APP_KEY_HEADER]: configuration.apiKey,
    };
  }

  public execute(request: FasterRequest): Promise<Response> {
    const url = this.baseUrl.replace(/\/*$/, '') + '/' + request.endpoint().replace(/^\/*/, '');
    const headers = new Headers();

    Object.entries(this.baseHeaders).forEach(([key, value]): void => headers.append(key, value));
    Object.entries(request.headers()).forEach(([key, value]): void => headers.append(key, value));

    this.currentRequest = this.currentRequest.then(async (): Promise<void> => {
      await this.tryRequest(url, request, headers);
    });
    return this.currentRequest;
  }

  private tryRequest(url: string, request: FasterRequest, headers: Headers) {
    const body = this.addSendAt(request.body());
    return fetch(url, {
      method: request.method,
      body: JSON.stringify(body),
      headers: headers,
    })
      .then((response) => {
        if (!response) {
          return;
        }

        if (response.status >= 400 && response.status <= 499) {
          const error = new Error('Client error on request to Faster');
          throw Object.assign(error, { response, retry: false });
        }

        if (response.status >= 500 && response.status <= 599) {
          const error = new Error('Server error on request to Faster');
          throw Object.assign(error, { response, retry: true });
        }
      })
      .catch(async (error) => {
        console.warn('Error occurred on request to Faster:', url, error);
        if (error.retry === false) {
          this.currentRequest = Promise.resolve();

          throw error;
        }

        await delay(1000)().then(async () => await this.tryRequest(url, request, headers));
      });
  }

  public async executeWithoutRetry(request: FasterRequest, headers: Headers = null): Promise<Response> {
    const body = request.body === undefined ? null : JSON.stringify(request.body());
    const url = this.baseUrl.replace(/\/*$/, '') + '/' + request.endpoint().replace(/^\/*/, '');

    const response = await fetch(url, {
      method: request.method,
      body: body,
      headers: headers,
    });
    return Promise.resolve(response);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private addSendAt(body: Record<string, any>): Record<string, any> {
    if (body === undefined) return null;
    const ntpDate = ServerDate.now();
    Object.assign(body, {
      sentAt: new Date(),
      ntpsentAt: ntpDate,
    });
    return body;
  }
}
